export default __webpack_public_path__ + "static/ccijcXMy-da8bcefd7f1a619debfdb31bcd6d7fb9.svg";